export const navItems = [
  { label: 'Overview', to: '/dashboard', icon: 'ri-dashboard-line', end: true },
  { label: 'Members', to: '/dashboard/members', icon: 'ri-group-line', end: false },
  { label: 'Points ledger', to: '/dashboard/transactions', icon: 'ri-history-line', end: false },
  { label: 'Rewards', to: '/dashboard/rewards', icon: 'ri-gift-2-line', end: false },
  { label: 'Redemptions', to: '/dashboard/redemptions', icon: 'ri-checkbox-circle-line', end: false },
  { label: 'Sponsors', to: '/dashboard/sponsors', icon: 'ri-megaphone-line', end: false },
  { label: 'Integrations', to: '/dashboard/integrations', icon: 'ri-plug-line', end: false },
  { label: 'Settings', to: '/dashboard/settings', icon: 'ri-settings-3-line', end: false },
];
